module.exports = __webpack_public_path__ + "media/images/Acuvue_banner-edc15a04f325124bf30bee3c7b3bb009.jpg";